import moment from 'moment';
export default {
    methods: {
        //funciones para el filtro
        customFilter(items, filters, filter, headers) {
            // Init the filter class.
            const cf = new this.$MultiFilters(items, filters, filter, headers);
            cf.registerFilter("fecha", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.fecha + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("descripcion", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.descripcion + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase()) || (item.descripcion + "")
                            .toLowerCase()
                            .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("tipo", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.tipo + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
  
            cf.registerFilter("estado", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.estado + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });

            return cf.runFilters();
        },

        filterFecha(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                fecha: val
            });
        },
        filterDescripcion(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                descripcion: val
            });
        },
        filterTipo(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                tipo: val
            });
        },
        filterEstado(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                estado: val
            });
        },
       
        recargar() {
            this.form = {};
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                fecha: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                descripcion: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                tipo: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                objeto_contratacion: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                estado: ""
            });
           
        },
    }
};


// WEBPACK FOOTER //
// ./src/components/admin/feriado/mixins/filtros.js